import React, { useState, useEffect } from "react";
import { Button, message, Modal, Form, Input, Typography } from "antd";
import inputStyles from "../../../../styles/Custom/Input.module.css";
import { raiseDeleteServiceRequestOpApi } from "../../../../services/receptionist.services";
import { CloseOutlined } from "@ant-design/icons";
import modalStyles from "../../DeleteReasonModal.module.css";

const DeleteServiceModal = ({
  open,
  setOpen,
  editData,
  refresh,
  selectedRowKeys,
  setSelectedRowKeys,
}) => {
  const [reason, setReason] = useState(null);
  const [isMobile, setIsMobile] = useState(() =>
    typeof window !== "undefined"
      ? window.matchMedia("(max-width: 768px)").matches
      : false
  );

  useEffect(() => {
    const mq = window.matchMedia("(max-width: 768px)");
    const onChange = () => setIsMobile(mq.matches);
    onChange();
    mq.addEventListener("change", onChange);
    return () => mq.removeEventListener("change", onChange);
  }, []);

  const onFinish = () => {
    if (editData) {
      raiseDeleteServiceRequestOpApi({
        id: editData,
        reason: reason,
      })
        .then((res) => {
          message.success(res?.data?.message);
          setOpen(false);
          refresh();
          setSelectedRowKeys([]);
        })
        .catch((err) => {
          message.error(err?.response?.data?.message);
        });
    } else {
      message.error("Please select a practitioner");
    }
  };

  return (
    <Modal
      open={open}
      footer={null}
      onCancel={() => setOpen(false)}
      closable={isMobile}
      title={isMobile ? "Reason" : undefined}
      centered={!isMobile}
      width={isMobile ? "min(400px, calc(100vw - 24px))" : undefined}
      wrapClassName={isMobile ? modalStyles.compactModalWrap : undefined}
    >
      {!isMobile && (
        <div
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
            gap: 12,
            marginBottom: 12,
          }}
        >
          <Typography.Text style={{ fontWeight: 600 }}>Reason</Typography.Text>
          <CloseOutlined
            onClick={() => setOpen(false)}
            style={{ cursor: "pointer", color: "#667085" }}
          />
        </div>
      )}

      <Form.Item
        name="Reason"
        className={isMobile ? modalStyles.compactFormItem : undefined}
        style={{ marginBottom: 16 }}
      >
        <Input.TextArea
          placeholder="Enter reason"
          className={inputStyles.mdInput}
          style={{ width: isMobile ? "100%" : "100%" }}
          rows={isMobile ? 3 : undefined}
          onChange={(e) => setReason(e.target.value)}
        />
      </Form.Item>

      <div
        className={isMobile ? modalStyles.compactFooter : undefined}
        style={
          isMobile
            ? undefined
            : { display: "flex", justifyContent: "flex-end", gap: 12 }
        }
      >
        <Button onClick={() => setOpen(false)}>Cancel</Button>
        <Button type="primary" onClick={onFinish}>
          OK
        </Button>
      </div>
    </Modal>
  );
};

export default DeleteServiceModal;
